export default __webpack_public_path__ + "static/media/Saul_Sampler_Shorter.8ed67463.mp3";